"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactReduxRequest = void 0;
const CreateLogic_1 = require("./CreateLogic");
const CreateReducer_1 = require("./CreateReducer");
class ReactReduxRequest {
    constructor(props) {
        this.props = props;
    }
    createLogic() {
        // TODO - Add settings
        return this.identifiers.map((identifier) => (0, CreateLogic_1.createRequestLogic)(identifier, {}));
    }
    createReducer() {
        const reducer = {};
        this.identifiers.forEach((identifier) => Object.assign(reducer, { [identifier]: (0, CreateReducer_1.createReducer)(identifier) }));
        return reducer;
    }
    get identifiers() {
        return [...this.props.identifiers.public, ...this.props.identifiers.secure];
    }
    get settings() {
        return this.props.settings;
    }
}
exports.ReactReduxRequest = ReactReduxRequest;
exports.default = ReactReduxRequest;
